import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'settings',
  children: {
    referral_program: {
      path: 'referral-program',
    },
  },
} as const satisfies Location
